import { IFilterField, IFilter } from '@/types/filter';

export const defaultFiltersValue: IFilter = {
  status: 'QA_OPEN',
  page: '1',
  size: '10',
};

// filtersData stores all filters attributes, default is input field
export const filtersData: IFilterField[] = [
  {
    name: 'supplier',
    label: 'Supplier',
    defaultValue: '',
    isDropdown: true,
    dropdownOptionsName: 'supplierOptions',
    isAdvanced: false,
  },
  {
    name: 'resolutionType',
    label: 'Customer Resolution',
    defaultValue: '',
    isDropdown: true,
    dropdownOptionsName: 'resolutionTypeOptions',
    isAdvanced: false,
  },
  {
    name: 'lotNo',
    label: 'Lot Number',
    defaultValue: '',
    placeholder: 'LOT Number',
    type: 'text',
    isText: true,
    isAdvanced: false,
  },
  {
    name: 'productName',
    label: 'Product Name',
    defaultValue: '',
    placeholder: 'Product Name',
    type: 'text',
    isText: true,
    isAdvanced: false,
  },
  {
    name: 'boxId',
    label: 'Box ID',
    defaultValue: '',
    placeholder: 'Box ID',
    type: 'text',
    isText: true,
    isAdvanced: false,
  },
  {
    name: 'skuNo',
    label: 'SKU No',
    defaultValue: '',
    placeholder: 'SKU No',
    type: 'text',
    isText: true,
    isAdvanced: false,
  },
];

export const advancedFiltersData: IFilterField[] = [
  {
    name: 'claimCategory',
    label: 'Claim Category',
    defaultValue: '',
    isDropdown: true,
    dropdownOptionsName: 'claimCategoryOptions',
    isAdvanced: true,
  },
  {
    name: 'claimIssueCategory',
    label: 'Claim Issue Category',
    defaultValue: '',
    isDropdown: true,
    dropdownOptionsName: 'claimIssueCategoryOptions',
    isAdvanced: true,
  },
  {
    name: 'claimIssueType',
    label: 'Claim Issue Type',
    defaultValue: '',
    isDropdown: true,
    dropdownOptionsName: 'claimIssueTypeOptions',
    isAdvanced: true,
  },
  {
    name: 'isClaimFlagged',
    label: 'Flagged',
    defaultValue: '',
    isDropdown: true,
    dropdownOptionsName: 'claimFlagOptions',
    isAdvanced: true,
  },
  // Temp disable the filters for Severity, Priority, Tag
  // {
  //   name: 'claimDefectSeverity',
  //   label: 'Claim Defect Severity',
  //   defaultValue: '',
  //   isDropdown: true,
  //   dropdownOptionsName: 'claimDefectSeverityOptions',
  //   isAdvanced: true,
  // },
  // {
  //   name: 'claimPriority',
  //   label: 'Claim Priority',
  //   defaultValue: '',
  //   isDropdown: true,
  //   dropdownOptionsName: 'claimPriorityOptions',
  //   isAdvanced: true,
  // },
  // {
  //   name: 'tag',
  //   label: 'Claim Tag',
  //   defaultValue: '',
  //   isDropdown: true,
  //   dropdownOptionsName: 'claimTagOptions',
  //   isAdvanced: true,
  // },
  {
    name: 'dateDeliveredBegin',
    label: 'Order Delivered Date From',
    defaultValue: '',
    isDate: true,
    isAdvanced: true,
  },
  {
    name: 'dateDeliveredEnd',
    label: 'Order Delivered Date To',
    defaultValue: '',
    isDate: true,
    isAdvanced: true,
  },
  {
    name: 'isProductQualityIssue',
    label: 'Product Quality Issue',
    defaultValue: '',
    isDropdown: true,
    dropdownOptionsName: 'claimProductQualityIssueOptions',
    isAdvanced: true,
  },
];
